// Enumerators
export const E_MainMenus = Object.freeze({
    Main: Symbol("main"),
    Pedana: Symbol("pedana"),
    Paraventi: Symbol("paraventi"),
    Ombrelloni: Symbol("ombrelloni"),
    Cristal: Symbol("cristal"),
    Calcolatore: Symbol("calcolatore"),
})
export const E_MainLato = Object.freeze({
    Scegli: Symbol("-Scegli-"),
    Lato1: Symbol("lato1"),
    Lato2: Symbol("lato2"),
    Lato3: Symbol("lato3"),
    Lato4: Symbol("lato4"),    
})
export const E_PedanaStepAltezza = Object.freeze({
    Da0a50: Symbol(0),
    Da50a95: Symbol(0.095),    
    Da95a125: Symbol(0.125),
    Da125a250: Symbol(0.250),   
})
export const E_PedanaRivestimento = Object.freeze({
    WPC: Symbol("WPC"),
    ANGELIM: Symbol("ANGELIM"),   
})
export const E_TipoParavento = Object.freeze({
    Slim_100: Symbol("Slim_100"),
    Unico_100: Symbol("Unico_100"),
    Unico_150: Symbol("Unico_150"),
    Smeraldo: Symbol("Smeraldo"),
    Rubino: Symbol("Rubino"),
    Topazio: Symbol("Topazio"),
    Screen_Up_100: Symbol("Screen_Up_100"),
})
export const E_GenereOmbrellone = Object.freeze({
    Braccio: Symbol("Braccio"),
    Centrale: Symbol("Centrale"),
    Sbalzo: Symbol("Sbalzo"),
})
export const E_TipoOmbrellone = Object.freeze({
    Scegli: Symbol("-Scegli-"),
    Avantage: Symbol("Avantage"),
    DeLuxe: Symbol("DeLuxe"),
    Diffusion: Symbol("Diffusion"),
    Roma: Symbol("Roma"),
    Facility: Symbol("Facility"),
    Mezzombra: Symbol("Mezzombra"),
    PlatinoBasic: Symbol("Platino Basic"),
    PlatinoMedium: Symbol("Platino Medium"),
    PratiqueClassic: Symbol("Pratique Classic"),
    PratiqueContract: Symbol("Pratique Contract"),
})
export const E_MisureOmbrelloni = Object.freeze({
    Scegli: Symbol("-Scegli-"),
    _1X3: Symbol("1X3"),
    _1mX2: Symbol("1,5X2"),
    _1mX3: Symbol("1,5X3"),
    _1mX4: Symbol("1,5X4"),
    _2X2: Symbol("2X2"),
    _2X2m: Symbol("2X2,5"),
    _2X3: Symbol("2X3"),
    _2X3m: Symbol("2X3,5"),
    _2X4: Symbol("2X4"),
    _3X3: Symbol("3X3"),
    _3mX3m: Symbol("3,5X3,5"),
    _3mX5: Symbol("3,5X5"),
    _3X4: Symbol("3X4"),
    _3X5: Symbol("3X5"),
    _3X6: Symbol("3X6"),
    _3X7: Symbol("3X7"),
    _4X4: Symbol("4X4"),
    _4mX4m: Symbol("4,5X4,5"),
    _4mX5m: Symbol("4,5X5,5"),
    _4X5: Symbol("4X5"),
    _4X6: Symbol("4X5"),
    _5X5: Symbol("5X5"),
    _5X6: Symbol("5X6"),
    _5X7: Symbol("5X7"),
    _5mX5m: Symbol("5,5X5,5"),
    _6X6: Symbol("6X6"),
    Automatica: Symbol("Automatica"),
})
export const E_ColoriMetallo = Object.freeze({
    Nero: Symbol("Nero"),
    Antracite: Symbol("Antracite"),
    Bianco: Symbol("Bianco"),   
})
export const E_ColoriTessuto = Object.freeze({
    T5: Symbol("T5"),  
    T12_15: Symbol("T12/15"),
    T14: Symbol("T14"),      
    T15: Symbol("T15"),      
    T15_93: Symbol("T15/93"),    
    T24: Symbol("T24"),    
    T73: Symbol("T73"),    
    T79: Symbol("T79"),   
    T81: Symbol("T81"),    
    T92: Symbol("T92"),   
    T93_15: Symbol("T93/15"),
    T97_15: Symbol("T97/15"),     
    T106: Symbol("T106"),     
    T151_15: Symbol("T151/15"),    
    T426: Symbol("T426"),    
    T926: Symbol("T926"),     
    T986_727: Symbol("T986/727"),  
})
export const E_ConfOmbrelloniContrapposti = Object.freeze({
    InLinea: Symbol("InLinea"),
    Compatta: Symbol("Compatta"),
})
export const E_KitLedOmbrelloni = Object.freeze({
    kit0_5m: Symbol("Kit 0,5m"),
    kit1m: Symbol("Kit 1m"),
    kit2m: Symbol("Kit 2m"),
})